import { render, staticRenderFns } from "./AdminEmbroideryCategoriesEditScreen.vue?vue&type=template&id=7ecd6240&scoped=true&"
import script from "./AdminEmbroideryCategoriesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminEmbroideryCategoriesEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd6240",
  null
  
)

export default component.exports